import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import IndentModal from "../components/indentModal";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddStockTransferNote = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [formData, setFormData] = useState({newPurNo: "", branches: "", shift: "" });
  const [stnNo, setStnNo] = useState('');
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();

  const canEntry = hasPermission("STN Outward", "entry");


  const fetchDataWithProgress = async () => {
  let progress = 0;
  let interval;

  // Show SweetAlert with progress % UI
  Swal.fire({
    title: "Fetching STN Details",
    html: `
      <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
        <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
      </div>
      <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");

      interval = setInterval(() => {
        progress += 5;
        if (progress > 100) progress = 100;
        if (bar) bar.style.width = `${progress}%`;
        if (text) text.innerText = `Loading... ${progress}%`;
      }, 100);
    },
  });

  try {
    // Parallel fetch of both endpoints
    const [stnRes, branchRes] = await Promise.all([
      axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutward_no?branch=${branch}`),
      axios.get(`https://rfs2.infraconsoft.net.in/api/stn_branch`)
    ]);

    // Set data from responses
    const stnNumber = parseInt(stnRes.data.stnNumber, 10) || 0;
    setStnNo(stnNumber.toString());
    setFormData(prev => ({ ...prev, newPurNo: stnNumber.toString() }));

    setBranches(branchRes.data.branch || []);

    progress = 100;
    document.getElementById("progress-bar").style.width = "100%";
    document.getElementById("progress-text").innerText = "Loading... 100%";

    // Close the SweetAlert after small delay
    setTimeout(() => Swal.close(), 500);

  } catch (error) {
    console.error("Error fetching data:", error);
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: "Something went wrong while fetching data.",
    });
  } finally {
    clearInterval(interval);
  }
};

useEffect(() => {
  {canEntry && (
  fetchDataWithProgress()
  )}
}, [branch]);

  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [...prevItems, { ...item, vcode: "", vnumber: "", qty: "", duedate: "" }]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    const updatedItems = [...selectedItems];
    updatedItems[index][field] = parseFloat(value) || 0; 
    setSelectedItems(updatedItems);
  };
  
 
    


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Function to submit the form data
  const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ To Branch validation
  if (!formData.branches || !formData.branches.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Select To Branch!",
    });
    return;
  }

  // ✅ Shift validation
  if (!formData.shift?.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please Select Shift!",
    });
    return;
  }

  // ✅ At least one item validation
  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // ✅ Item validations
  for (let i = 0; i < selectedItems.length; i++) {
    const item = selectedItems[i];
    const index = i + 1;

    // Quantity check
    if (!item.qty || isNaN(item.qty) || Number(item.qty) <= 0) {
      Swal.fire({
        icon: "warning",
        title: `Invalid Quantity (Row ${index})`,
        text: `Enter Quantity and it should be a positive number.`,
      });
      return;
    }

    // Stock check
    if (!item.itemmaster_closingStock || Number(item.itemmaster_closingStock) <= 0) {
      Swal.fire({
        icon: "error",
        title: `No Stock Available (Row ${index})`,
        text: `Item "${item.itemmaster_name}" has no stock.`,
      });
      return;
    }

    // Qty vs Stock check
    if (Number(item.qty) > Number(item.itemmaster_closingStock)) {
      Swal.fire({
        icon: "error",
        title: `Insufficient Stock (Row ${index})`,
        text: `Item "${item.itemmaster_name}" has only ${item.itemmaster_closingStock} in stock, but you entered ${item.qty}.`,
      });
      return;
    }
  }

  // ✅ Build payload
  const payload = {
    branch: branch,
    stnNo: formData.newPurNo,
    user: userId,
    toBranch: formData.branches,
    shift: formData.shift,
    remarks: formData.remarks,
    items: selectedItems.map((item) => ({
      itemCode: item.itemmaster_code,
      itemName: item.itemmaster_name,
      uom: item.itemmaster_uom,
      price: item.itemmaster_price,
      qty: item.qty,
    })),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/stnOutward_insert",
      payload
    );

    Swal.fire("Success", "STN Outwarded successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/stockTransferNoteView");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

  
if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">STOCK TRANSFER NOTE - Add</h2>
                    <Link to='/inventory/stockTransferNoteView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

       

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Stock Transfer No :</label>
                <input type="text" name="newPurNo" value={formData.newPurNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
              <label>To Branch :</label>
                <select name="branches" value={formData.branches} onChange={handleChange}>
                  <option value="">-- Select Branch --</option>
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
              <label>Shift :</label>
                <select name="shift" value={formData.shift} onChange={handleChange}>
                  <option value="">-select-</option> 
                  <option value="1">1</option> 
                  <option value="2">2</option> 
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Transfer Type :</label>
                <input type="text" name="hod" value="Outward" onChange={handleChange} readOnly/>
              </div>
            </div>

           


          <div className="flex_buttons">
          <button type="button" className="button button-add" onClick={() => setShowModal(true)}>Add Item</button>
        </div>
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Stock</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Value</th>  
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
  {selectedItems.length > 0 ? (
    selectedItems.map((item, index) => {
      const value = item.itemmaster_price * item.qty || 0;
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.itemmaster_code}</td>
          <td>{item.itemmaster_drawingNumber}</td>
          <td>{item.itemmaster_name}</td>
          <td>{item.itemmaster_uom}</td>
          <td>{item.itemmaster_closingStock}</td>
          <td>{item.itemmaster_price}</td>
          <td>
            <input
              type="text"
              value={item.qty}
              onChange={(e) => handleRowChange(index, "qty", e.target.value)}
            />
          </td>
          <td>{value.toFixed(2)}</td> 
          <td className="del">
            <i
              className="fa-solid fa-trash-can"
              onClick={() => handleDeleteRow(index)}
            ></i>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No items added</td>
    </tr>
  )}
</tbody>

              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>

          </form>
        </div>
      </div>
      <IndentModal showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} />
    </div>
  );
};

export default AddStockTransferNote;